import 'src/BentoThemeProvider.css.ts.vanilla.css?source=LndnYmIwdzAgewogIGRpc3BsYXk6IGNvbnRlbnRzOwp9';
export var bentoThemeProvider = 'wgbb0w0';